import React from 'react';

export function PageCover(props) {

    function closeOnClick(id) {
        if(id === "page-cover") {
            props.toggleBackgroundCover()
        }
    }

    if(props.pagecover === true) {
        return(
            <div className="page-cover" id="page-cover" onClick={(e) => closeOnClick(e.target.id)}
            style={{
                position: "absolute",
                backgroundColor: "rgba(0,0,0,0.2)",
                width: "100vw",
                height: "100vh",
                zIndex: "3",
                minWidth: "1400px",
                minHeight: "750px"
            }}
            >
            </div>
        )
    } else {
        return null
    }
}